module.exports = __webpack_public_path__ + "static/media/dlp_slide.165e6be3.svg";